import { render, staticRenderFns } from "./MergeDataPage.vue?vue&type=template&id=022e2e5a&scoped=true&"
import script from "./MergeDataPage.vue?vue&type=script&lang=js&"
export * from "./MergeDataPage.vue?vue&type=script&lang=js&"
import style0 from "./MergeDataPage.vue?vue&type=style&index=0&id=022e2e5a&lang=scss&scoped=true&"
import style1 from "./MergeDataPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022e2e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022e2e5a')) {
      api.createRecord('022e2e5a', component.options)
    } else {
      api.reload('022e2e5a', component.options)
    }
    module.hot.accept("./MergeDataPage.vue?vue&type=template&id=022e2e5a&scoped=true&", function () {
      api.rerender('022e2e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/data/mergeData/MergeDataPage.vue"
export default component.exports